import type { ArchetypeId } from './archetypes';

/**
 * Per-archetype kit color. Numeric 0xRRGGBB because Phaser `setTint`
 * requires a packed integer, not a "#rrggbb" string. CSS-facing code
 * must serialize via `toCssHex`. Locked palette — see spec §2.3.
 *
 * Plan #11 final art briefing reads this constant; final kit colors
 * must match (or update both this constant and the spec atomically).
 */
export const ARCHETYPE_KIT_COLORS: Record<ArchetypeId, number> = {
  DIVER: 0xdc2626,
  HIGH_WALL: 0xeab308,
  LEFT_LEANER: 0x06b6d4,
  CENTER_SPREAD: 0x22c55e,
  WIDE_OPEN: 0x94a3b8,
  TWO_CLUSTER: 0xa855f7,
};

export function toCssHex(c: number): string {
  return `#${c.toString(16).padStart(6, '0')}`;
}
